import React from 'react';
import { IonButton, IonContent, IonModal } from '@ionic/react';
import { Achievement } from '@/types/achievements';
import { ProgressCircle } from '../ui/progress-circle';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

interface AchievementDetailModalProps {
  achievement: Achievement | null;
  isOpen: boolean;
  onClose: () => void;
}

export const AchievementDetailModal: React.FC<AchievementDetailModalProps> = ({
  achievement,
  isOpen,
  onClose
}) => {
  const { t } = useTranslation('MGP');

  if (!achievement) return null;

  const { icon, title, description, earned, progress, total, earnedDate } = achievement;

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onClose}
      className="achievement-detail-modal"
      initialBreakpoint={0.75}
      breakpoints={[0, 0.75]}
    >
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center justify-center p-4 text-center">
          <div className="mb-6 mt-4">
            <ProgressCircle
              value={progress}
              max={total}
              radius={48}
              strokeWidth={earned ? 4 : 4}
              variant={earned ? "success" : "default"}
              className="size-24"
            >
              <div className="relative">
                <img
                  src={`/assets/images/badges/${icon}.webp`}
                  alt={icon}
                  className={cn("size-full p-2", !earned && "dark:invert grayscale opacity-40 brightness-0")}
                />
              </div>
            </ProgressCircle>
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold mb-2">{title}</h2>

          {/* Earned Date */}
          {earned && earnedDate && (
            <p className="text-sm text-muted-foreground mb-4">
              {t('earned_on', 'Obtenu le')} {new Date(earnedDate).toLocaleDateString()}
            </p>
          )}

          {/* Description */}
          <p className="text-base mb-8">{description}</p>

          {/* Close Button */}
          <IonButton
            expand="block"
            fill="outline"
            onClick={onClose}
            className="w-full max-w-xs"
          >
            {t('close', 'Fermer')}
          </IonButton>
        </div>
      </IonContent>
    </IonModal>
  );
};
